(function () {
  'use strict';

  if (window.PGPrivacyImmediateC01) return;
  window.PGPrivacyImmediateC01 = true;

  function hasSettledChoice(api) {
    if (!api || typeof api.currentVisitorConsent !== 'function') return false;
    try {
      var consent = api.currentVisitorConsent() || {};
      return ['preferences', 'analytics', 'marketing'].every(function (key) {
        return consent[key] === 'yes' || consent[key] === 'no';
      });
    } catch (e) {
      return false;
    }
  }

  function revealWhenRequired() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    var banner = document.getElementById('pgpc-banner');
    if (!api || !banner || typeof api.shouldShowBanner !== 'function') return false;

    if (hasSettledChoice(api)) return true;

    try {
      if (!api.shouldShowBanner()) return true;
    } catch (e) {
      return false;
    }

    banner.hidden = false;
    document.documentElement.classList.add('pgpc-consent-visible');
    if (window.PGPrivacyCentreV2 && typeof window.PGPrivacyCentreV2.refreshChat === 'function') {
      window.PGPrivacyCentreV2.refreshChat();
    }
    return true;
  }

  function start() {
    var attempts = 0;
    (function poll() {
      if (revealWhenRequired()) return;
      attempts += 1;
      if (attempts < 120) window.setTimeout(poll, 50);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(start, 0);
    }, { once: true });
  } else {
    start();
  }
})();
